<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <!-- <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" v-if="addNewDataSidebar" /> -->

    <vs-table v-if="permissions_list" pagination :max-items="itemsPerPage" search :data="lists" ref="table">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->
          <vs-button :size="largeScreenWidth ? '' : 'small'" color="primary" type="filled" @click="addNewData"
            v-if="permissions_create" icon="icon-plus" icon-pack="feather">Add New</vs-button>
          <!-- <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary btn-sm" @click="addNewData" v-if="permissions_create">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown :disabled="lists.length == 0" vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span v-if="lists.length > 0" class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) + itemsPerPage
            }} - {{ lists.length - currentPage * itemsPerPage > 0 ? (queriedItems > itemsPerPage ? currentPage *
  itemsPerPage + itemsPerPage : queriedItems) : lists.length }} of {{ queriedItems }}</span>
            <span v-else>0 of 0</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="account_no">Account</vs-th>
        <vs-th sort-key="created_at">Created at</vs-th>
        <vs-th sort-key="loan_amount">Amount</vs-th>
        <vs-th sort-key="customer_name">Customer</vs-th>
        <vs-th sort-key="loan_collector">Collector</vs-th>
        <vs-th sort-key="loan_status">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="font-medium truncate">{{ tr.account_no }}</p>
            </vs-td>

            <vs-td>
              <p class="created_at">{{ formatDate(tr.created_at) }}</p>
            </vs-td>
            <vs-td>
              <p class="loan_amount">{{ tr.loan_amount }}</p>
            </vs-td>
            <vs-td>
              <p class="customer_name">{{ tr.customer.name }} <b>{{ (user_info.role == 'DEVELOPER' || user_info.role ==
                'SUPERADMIN') ? '(' + getGroup(tr.groupid) + ')' : '' }}</b></p>
            </vs-td>

            <vs-td>
              <p class="loan_collector">{{ tr.loan_collector }}</p>
            </vs-td>

            <vs-td>
              <p class="loan_status">{{ tr.loan_status }}</p>
            </vs-td>

            <!-- <vs-td>
                <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" />
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.order_status)" class="order-status">{{ tr.order_status | title }}</vs-chip>
              </vs-td> -->

            <!-- <vs-td>
                <p class="price">${{ tr.price }}</p>
              </vs-td> -->

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)" />
              <!-- <feather-icon v-show="permissions_update" :icon="classObject(tr.status)" :svgClasses="svgClass(tr.status)" class="ml-2" @click.stop="updateStatus(tr)" /> -->
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <h5 v-else>Not allowed to view loan list</h5>
  </div>
</template>

<script>
// import DataViewSidebar from './sidebar.vue'
// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    // DataViewSidebar
  },
  data() {
    return {
      // selected: [],
      lists: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      // addNewDataSidebar: false,
      // sidebarData: {}
    }
  },
  computed: {
    largeScreenWidth() {
      if (window.innerWidth > 575) {
        return true
      }
      else
        return false
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    permissions() {
      return this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions ? this.$store.state.AppActiveUser.permissions : [];
    },
    permissions_create() {
      return this.hasPermission('031');
    },
    permissions_list() {
      return this.hasPermission('032');
    },
    permissions_update() {
      return this.hasPermission('033');
    },
    permissions_delete() {
      return this.hasPermission('034');
    },
    users() {
      return this.$store.state.userManagement.users;
    },
    loans() {
      return this.$store.state.userManagement.loans;
    },
    user_info() {
      const data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.lists.length
    },
    groupid_list() {
      let self = this
      let temp = []

      this.users.forEach(function (item) {
        if (item.role !== 'WORKER') {
          temp.push({
            groupid: item.groupid,
            name: item.name
          })
        }
      })

      return temp
    },
  },
  methods: {
    hasPermission(permissionCode) {
      return this.permissions.includes('*') || this.permissions.includes(permissionCode);
    },
    getGroup(groupid) {
      let temp = ''
      this.groupid_list.forEach(function (item) {
        if (item.groupid == groupid) {
          temp = item.name
        }
      })
      return temp
    },
    classObject(status) {
      if (status == 'ACTIVE') {
        return 'LockIcon'
      }
      else {
        return 'UnlockIcon'
      }
    },
    svgClass(status) {
      if (status == 'ACTIVE') {
        return 'w-5 h-5 stroke-current text-danger'
      }
      else {
        return 'w-5 h-5 stroke-current text-success'
      }
    },
    addNewData() {
      this.$router.push(`/loan_detail/new`).catch(() => { })
      // this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    updateStatus(data) {
      let self = this
      let new_status = data.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Update Status',
        text: `You are about to set "${data.name}" to "${new_status}"`,
        acceptText: 'Confirm',
        accept: function () {
          let formData = new FormData();
          formData.append('_method', 'PUT')
          formData.append('status', data.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')

          let obj = {
            uuid: data.uuid,
            form_data: formData
          }

          self.$store.dispatch('userManagement/updateStatus', obj).catch(err => { console.error(err) })
        }

      })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      // this.sidebarData = data
      this.$router.push(`/loan_detail/${data.uuid}`).catch(() => { })
      // this.toggleDataSidebar(true)
    },
    // toggleDataSidebar (val = false) {
    // this.addNewDataSidebar = val
    // this.$store.dispatch("userManagement/fetchUsers")
    // }
  },
  created() {
    if (this.permissions_list && this.loans.length <= 0) {
      this.$vs.loading()
      const baseURI = 'loans/list'
      let formData = new FormData();
      formData.append('status', 'ACTIVE,COMPLETE');
      this.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            console.log(result.data.data)
            this.$vs.loading.close()
            this.lists = result.data.data
          }
        })
        .catch((err) => {
          if (err.logout) {
            this.$vs.loading.close()
            this.$vs.notify({
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              title: err.msg
            })
            sessionStorage.removeItem('accessToken')
            sessionStorage.removeItem('user')
            sessionStorage.removeItem('loan_info')
            this.$router.push('/pages/login').catch(() => { })
          }
        })
    }
    else{
      this.lists = this.loans
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }

        td>span>.select-none {
          cursor: pointer;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}</style>
